export default __webpack_public_path__ + "static/media/carousel3.db884230.jpg";